import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getExpenseSheetByAccountEmployeeIdAsync, checkedState, updateMasterExpenseSheetId, getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync, unCheckedState, checkedAllState, unCheckedAllState, deleteExpenseSheetAsync, addAccountExpenseSheetCopyAsync, updateSorting } from '../expenseSlice';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, setItemStatus, getValueFromResource, dateFormatByAccountCulture } from "../../../common/timeLiveFunction";
import moment, { now } from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import clsx from "clsx";
const itemClass = 'ms-1 ms-lg-0';

const ExpenseSheetItem = (props: any) => {
    const { expenseSheetList, t, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const { DecimalPlaces, sortOrderExpenseSheet, sortColumnExpenseSheet } = useAppSelector((state) => state.expense);
    const { decimalPlaces, lockApprovedRecords, CurrentCultureDateFormat, cultureInfoName } = useAppSelector((state) => state.globalState);
    const navigate = useNavigate();
    // const [hoveredColumn, setHoveredColumn] = useState(null);

    const navigateToExpenseEntries = (obj: any) => {
        // navigate('/expenseentries', { state: { obj } });
        navigate(`/expenseentries/${obj.AccountEmployeeExpenseSheetId}`,{ state: { obj } });
        dispatch(updateMasterExpenseSheetId(obj.AccountEmployeeExpenseSheetId));
        //dispatch(getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync(obj.AccountEmployeeExpenseSheetId));
    };

    const navigateToAudit = (AccountEmployeeExpenseSheetId: any) => {
        const obj = {
            Id: AccountEmployeeExpenseSheetId,
            TableName: 'AccountEmployeeExpenseSheet',
            Title: getValueFromResource('Expense Sheet Audit', dispatch,t)
        }
        navigate(`/expenseaudit/${AccountEmployeeExpenseSheetId}`, { state: { obj } });
    };


    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onDeleteClick = (AccountEmployeeExpenseSheetId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteExpenseSheetAsync(AccountEmployeeExpenseSheetId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Expense Sheet Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const onCopyClick = (AccountEmployeeExpenseSheetId: string) => {
        dispatch(addAccountExpenseSheetCopyAsync(AccountEmployeeExpenseSheetId))
            .unwrap()
            .then((originalPromiseResult) => {
                ShowToast("Expense sheet copy Successfully", 'Success', "success", "toast-top-right");
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('onCopyClick-addAccountExpenseSheetCopyAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            });
    };

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn
        }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle " >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={expenseSheetList.every((item: any) => item.isSelected === 0) ? false :
                                            (expenseSheetList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        {/* className='w-10' */}
                        <th style={{ width: '15%' }}
                        // onMouseEnter={() => handleMouseEnter(0)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Date')} */}
                            {getValueFromResource('Date', dispatch, t)}
                            {sortColumnExpenseSheet === 'ExpenseSheetDate' ?
                                sortOrderExpenseSheet === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseSheetDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseSheetDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseSheetDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseSheetDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* className='w-50' */}
                        <th style={{ width: '55%' }}
                        // onMouseEnter={() => handleMouseEnter(1)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Description')} */}
                            {getValueFromResource('Description',dispatch, t)}
                            {sortColumnExpenseSheet === 'Description' ?
                                sortOrderExpenseSheet === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Description") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Description") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Description") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Description") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* className='w-15' */}
                        <th style={{ width: '15%' }}
                        // onMouseEnter={() => handleMouseEnter(2)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Amount')} */}
                            {getValueFromResource('Amount',dispatch, t)}
                            {sortColumnExpenseSheet === 'Amount' ?
                                sortOrderExpenseSheet === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 2 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* className='w-15' */}
                        <th style={{ width: '15%' }}
                        // onMouseEnter={() => handleMouseEnter(3)}
                        // onMouseLeave={handleMouseLeave}
                        >
                            {/* {t('Status')} */}
                            {getValueFromResource('Status',dispatch, t)}
                            {sortColumnExpenseSheet === 'Status' ?
                                sortOrderExpenseSheet === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 3 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Status") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Status") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {/* {expenseSheetList.length === 0 && <tr><td>{t('No Record Found.')}</td></tr>} */}
                    {expenseSheetList.length > 0 && expenseSheetList.map((expenseSheetDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={expenseSheetDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, expenseSheetDetail.AccountEmployeeExpenseSheetId) }}

                                        />
                                    </div>
                                </td>}
                            <td>
                                {/* {moment.parseZone(expenseSheetDetail.ExpenseSheetDate).format('DD MMM yy')} */}
                                {formatDateWithDateAndMonthName(expenseSheetDetail.ExpenseSheetDate, cultureInfoName.toString())}
                            </td>
                            <td
                                style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
                                onClick={IsEdit ? () => navigateToExpenseEntries({
                                    "AccountEmployeeExpenseSheetId": expenseSheetDetail.AccountEmployeeExpenseSheetId
                                }) : undefined} >
                                {expenseSheetDetail.Description}
                            </td>
                            <td>
                                {/* {expenseSheetDetail.CurrencyCode} {expenseSheetDetail.Amount.toFixed(DecimalPlaces)} */}
                                {expenseSheetDetail.CurrencyCode} {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseSheetDetail.Amount, decimalPlaces)}
                            </td>
                            <td>
                                <span className={clsx('expenseStatus-td app-navbar-item badge ', setItemStatus(expenseSheetDetail.Status))}>
                                    {expenseSheetDetail.Status}
                                </span>
                            </td>

                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>

                                        <>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0"
                                                            onClick={() => {
                                                                navigateToExpenseEntries({
                                                                    "AccountEmployeeExpenseSheetId": expenseSheetDetail.AccountEmployeeExpenseSheetId
                                                                });
                                                            }}
                                                        >
                                                            <span className="menu-icon custom-menu mb-2">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit Expense')}`} */}
                                                                {getValueFromResource('Edit Expense',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0 "
                                                    onClick={() => { onCopyClick(expenseSheetDetail.AccountEmployeeExpenseSheetId) }}
                                                >
                                                    <span className="menu-icon custom-menu mb-6">
                                                        <i className="bi bi-book fs-4 iconColor ">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">
                                                        {/* {`${t('Copy')}`} */}
                                                        {getValueFromResource('Copy',dispatch, t)}
                                                        </span>
                                                </Dropdown.Item>
                                            </div>
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0 "
                                                    onClick={() => navigateToAudit(expenseSheetDetail.AccountEmployeeExpenseSheetId)}
                                                >
                                                    <span className="menu-icon custom-menu mb-2">
                                                        <i className="bi bi-receipt fs-6 iconColor">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">
                                                        {/* {`${t('Audit')}`} */}
                                                        {getValueFromResource('Audit',dispatch, t)}
                                                        </span>
                                                </Dropdown.Item>
                                            </div>
                                        </>
                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }                                         
                                        {IsDelete && 
                                            (!lockApprovedRecords || expenseSheetDetail.Status !== 'Approved') && (
                                              <div className='menu-hover-bg-danger'>
                                                <Dropdown.Item
                                                  className="menu-item me-lg-0"
                                                  onClick={() => onDeleteClick(expenseSheetDetail.AccountEmployeeExpenseSheetId)}
                                                >
                                                  <span className="menu-icon custom-menu">
                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color align">
                                                      <span className="path1"></span>
                                                      <span className="path2"></span>
                                                    </i>
                                                  </span>
                                                  <span className="menu-title delete-menu custom-menu-fontsize">
                                                    {getValueFromResource('Delete', dispatch, t)}
                                                  </span>
                                                </Dropdown.Item>
                                              </div>
                                            )
                                          }
                                    </Dropdown.Menu>
                                </Dropdown>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {expenseSheetList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p>
                </div>
            }
        </>
    )
}

export default ExpenseSheetItem